// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"31229cff","890":"572286ac"}[chunkId] + ".chunk.js";
};